import type { ReactNode } from 'react';

export function Block({ children }: { children: ReactNode }) {
  return <div className="py-12 @lg:py-20">{children}</div>;
}
